module.exports = __webpack_public_path__ + "img/smart9.5d2436b8.png";